import { render, staticRenderFns } from "./k-video-player.vue?vue&type=template&id=5d9e1d96&lang=pug&"
import script from "./k-video-player.vue?vue&type=script&lang=js&"
export * from "./k-video-player.vue?vue&type=script&lang=js&"
import style0 from "./k-video-player.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d9e1d96')) {
      api.createRecord('5d9e1d96', component.options)
    } else {
      api.reload('5d9e1d96', component.options)
    }
    module.hot.accept("./k-video-player.vue?vue&type=template&id=5d9e1d96&lang=pug&", function () {
      api.rerender('5d9e1d96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/blocks/k-video-player.vue"
export default component.exports